import { useEffect } from 'react';

import { Spinner } from '@/components';
import { useJwtVerify, useLogout } from '@/hooks';
import { fixUrlForCloudFront } from '@/utils/cloudfront';

import styles from './VerifyToken.module.css';

export interface VerifyTokenProps {
  jwt?: string;
}

export function VerifyToken({ jwt: propJwt }: VerifyTokenProps) {
  const logout = useLogout();

  const { mutate } = useJwtVerify({
    handleSuccess: (data: Api.UserObject) => {
      window.location.href = fixUrlForCloudFront(
        `/connect/${data?.is_client ? 'campaigns' : 'collaborations'}`
      );
    },
    handleError: () => logout(),
    jwt: propJwt || ''
  });

  useEffect(() => mutate(), [mutate]);

  return (
    <div className={styles.verifyToken}>
      <Spinner hasWrapper />
    </div>
  );
}
